import * as THREE from 'three'
import React, { useEffect, forwardRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { ThreeElements } from '@react-three/fiber'
import { GLTF } from 'three-stdlib'

type GLTFResult = GLTF & {
  nodes: {
    DNA003: THREE.Mesh
    DNA011: THREE.Mesh
    DNA005: THREE.Mesh
    DNA010: THREE.Mesh
    DNA006: THREE.Mesh
    DNA007: THREE.Mesh
    DNA009: THREE.Mesh
    DNA004: THREE.Mesh
    DNA008: THREE.Mesh
  }
  materials: {
    Hologramm1: THREE.MeshStandardMaterial
    Hologramm2: THREE.MeshStandardMaterial
  }
}

const glowingMaterial = new THREE.MeshStandardMaterial({
  color: new THREE.Color("rgb(198, 112, 255)"), 
  emissive: new THREE.Color("rgb(154, 87, 255)"),
  emissiveIntensity: 1.0,
  metalness: 0.5,
  roughness: 0.2,
  toneMapped: false // Prevents tone mapping which can alter the color
});

// Convert to forwardRef to support rotation from parent
export const DnaModel = forwardRef<THREE.Group, ThreeElements['group']>((props, ref) => {
  const { nodes } = useGLTF('/models/holographic_dna.glb') as unknown as GLTFResult;
  
  useEffect(() => {
    Object.values(nodes).forEach((node) => {
      if (node instanceof THREE.Mesh) {
        node.material = glowingMaterial;
      }
    });
  }, [nodes]);

  return (
    <group {...props} ref={ref} dispose={null}>
    <mesh
      castShadow
      receiveShadow
      geometry={nodes.DNA003.geometry}
      material={glowingMaterial}
      position={[-4.023, 0.006, 0.003]}
      rotation={[0, 0, -Math.PI / 2]}
    />
    <mesh
      castShadow
      receiveShadow
      geometry={nodes.DNA011.geometry}
      material={glowingMaterial}
      position={[0.083, 0.613, -0.457]}
      rotation={[0, 0, -Math.PI / 2]}
      scale={1.238}
    />
    <mesh
      castShadow
      receiveShadow
      geometry={nodes.DNA005.geometry}
      material={glowingMaterial}
      position={[-4.023, 0.006, 0.003]}
      rotation={[0, 0, -Math.PI / 2]}
    />
    <mesh
      castShadow
      receiveShadow
      geometry={nodes.DNA010.geometry}
      material={glowingMaterial}
      position={[-0.16, 0.692, -0.401]}
      rotation={[0, 0, -Math.PI / 2]}
    />
    <mesh
      castShadow
      receiveShadow
      geometry={nodes.DNA006.geometry}
      material={glowingMaterial}
      position={[-4.023, 0.006, 0.003]}
      rotation={[-3.037, 0, -Math.PI / 2]}
    />
    <mesh
      castShadow
      receiveShadow
      geometry={nodes.DNA007.geometry}
      material={glowingMaterial}
      position={[-4.023, 0.006, 0.003]}
      rotation={[0, 0, -Math.PI / 2]}
    />
    <mesh
      castShadow
      receiveShadow
      geometry={nodes.DNA009.geometry}
      material={glowingMaterial}
      position={[-0.309, 0.087, -0.003]}
      rotation={[1.691, 0, -Math.PI / 2]}
    />
    <mesh
      castShadow
      receiveShadow
      geometry={nodes.DNA004.geometry}
      material={glowingMaterial}
      position={[-0.309, 0.087, -0.003]}
      rotation={[1.99, -0.08, 1.606]}
      scale={1.402}
    />
    <mesh
      castShadow
      receiveShadow
      geometry={nodes.DNA008.geometry}
      material={glowingMaterial}
      position={[-0.012, -0.014, 0.002]}
      rotation={[0, 0, -Math.PI / 2]}
    />
  </group>
  )
});

DnaModel.displayName = 'DnaModel';
// Preload the model to improve initial load time
useGLTF.preload('/models/holographic_dna.glb')
